import { combineReducers } from '@ngrx/store';
import { CompleteState } from './complete/state/complete_state';
import { completeReducer } from './complete/state/complete_reducer';
import { RegisterState } from './register/state/register_state';
import { registerReducer } from './register/state/register_reducer';
import { PlatformState } from './platform/state/platform_state';
import { platformReducer } from './platform/state/platform_reducer';
import { ProductState } from './product/state/product_state';
import { productReducer } from './product/state/product_reducer';
import { FinishState } from './finish/state/finish_state';
import { finishReducer } from './finish/state/finish_reducer';
import { PasswordFormState } from './shared/change_password/state/passwords_form_state';
import { changePasswordReducer } from './shared/change_password/state/passwords_form_reducer';

export interface SignupState {
  complete: CompleteState;
  register: RegisterState;
  platform: PlatformState;
  product: ProductState;
  finish: FinishState;
  changePassword: PasswordFormState;
}

export const signupReducer = combineReducers({
  complete: completeReducer,
  register: registerReducer,
  platform: platformReducer,
  product: productReducer,
  finish: finishReducer,
  changePassword: changePasswordReducer
});
